import { EventDispatcher, EventStream, REFERENCE_FPS } from '@cgs/wge';
import { ComponentIndex } from '../entities_engine/component_index';
import { EntitiesEngine } from '../entities_engine/entities_engine';
import { Entity } from '../entities_engine/entity';
import { ComponentNames } from '../entity_components/component_names';
import { SpeedInterpolation } from '../entity_components/speed_interpolation';
import { EntityCacheHolder } from '../game_components/entity_cache_holder';
import { InternalReelsConfig } from '../internal_reels_config';
import { BaseSystem } from './base_system';

export class AccelerationSystem extends BaseSystem {
  private readonly _speedIndex: ComponentIndex;
  private readonly _speedInterpolationIndex: ComponentIndex;
  private readonly _reelIndex: ComponentIndex;
  private readonly _lineIndex: ComponentIndex;
  private readonly _acceleratedLineCount: number[];
  private readonly _needToAccelerateLineCount: number[] = [];
  private readonly _config: InternalReelsConfig;
  private readonly _reelAccelerated: EventDispatcher<number>;
  public readonly reelAccelerated: EventStream<number>;

  constructor(
    engine: EntitiesEngine,
    entityCacheHolder: EntityCacheHolder,
    config: InternalReelsConfig
  ) {
    super(engine, entityCacheHolder);
    this._config = config;
    this._acceleratedLineCount = new Array<number>(this._config.reelCount).fill(0);
    this._reelAccelerated = new EventDispatcher<number>();
    this.reelAccelerated = this._reelAccelerated.eventStream;

    this._speedInterpolationIndex = this.engine.getComponentIndex(
      ComponentNames.AccelerationInterpolate
    );
    this._speedIndex = this.engine.getComponentIndex(ComponentNames.Speed);
    this._reelIndex = this.engine.getComponentIndex(ComponentNames.ReelIndex);
    this._lineIndex = this.engine.getComponentIndex(ComponentNames.LineIndex);
  }

  public getIndexesForFilter(): ComponentIndex[] {
    return [this._speedInterpolationIndex, this._speedIndex, this._reelIndex, this._lineIndex];
  }

  public processEntity(entity: Entity, dt: number): void {
    const interpolation: SpeedInterpolation = entity.get<SpeedInterpolation>(
      this._speedInterpolationIndex
    );

    if (!interpolation.isDone) {
      entity.set(this._speedIndex, interpolation.value);
      interpolation.step(dt * REFERENCE_FPS);
    } else {
      entity.removeComponent(ComponentNames.AccelerationInterpolate);
      this.fireEventIfNeed(entity);
    }
  }

  public registryAcceleratedLine(reel: number, lineCount: number): void {
    this._needToAccelerateLineCount[reel] = lineCount;
  }

  private fireEventIfNeed(entity: Entity): void {
    const reel: number = entity.get<number>(this._reelIndex);

    this._acceleratedLineCount[reel]++;

    if (this._acceleratedLineCount[reel] >= this._needToAccelerateLineCount[reel]) {
      this._acceleratedLineCount[reel] = 0;
      this._reelAccelerated.dispatchEvent(reel);
    }
  }
}
